import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-confirmation',
  templateUrl: './dialog-confirmation.component.html',
  styleUrls: ['./dialog-confirmation.component.css']
})
export class DialogConfirmationComponent implements OnInit {
  platform: any
  @Output() btnAction: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.platform = localStorage.getItem('platform');
  }

  save(value: number) {
    this.btnAction.emit(value);
  }
}
